import { ListColumn } from "../ListColumn";
import { ListView } from "../ListView";

export class QueryListView extends ListView{

    constructor(items:any){
        super();
        this.model = items;
    }

    columns!: ListColumn[];
    
}